import { Title } from '@angular/platform-browser';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { environment } from '@environments/environment';
import { tap } from 'rxjs/operators';

export interface ISocialMediaObject {
    active: boolean;
    link: string;
}
export interface ISocialMedia {
    facebook: ISocialMediaObject;
    twitter: ISocialMediaObject;
    instagram: ISocialMediaObject;
    linkedin: ISocialMediaObject;

}
export interface IContactUs {
    phone: string;
    timing: string;
    email: string;
    address: string;
}

export enum ISiteFeaturesEnum {
    SiteSettings = "siteSettings",
    MultiStore = "multiStore",
    AbandonedCart = "abandonedCart",
    Services = "services",
    Calendar = "calendar",
    Exports = "exports",
    Imports = "imports",
    Sectors = "sectors",
    Layouts = "layouts",
    Quotations = "quotations",
    Professionals = "professionals",
    Promotions = "promotions",
    Vouchers = "vouchers",
    UserManagement = "userManagement",
    Chat = "chat",
    CreditFacility = "creditFacility",
    Loyalty = "loyalty",
    PriceList = "priceList",
    Reports = "reports",
    EngagementReports = "engagementReports",
    Moderation = "moderation",
    Reviews = "reviews",
    Blogs = "blogs",
    AskQetaat = "askQetaat",
    QuotationRequests = "quotationRequests",
    OrderMessages = "orderMessages",
    Property = "property",
    PropertyManagement = "propertyManagement"
}

export type ISiteFeatures = {
    [key in ISiteFeaturesEnum]?: boolean;
}

interface ISiteSetting {
    loggedInOnly : boolean,
    companyId: string;
    logo: { url };
    favicon: string;
    header: {
        backgroundColor: string;
        foregroundColor: string;
        activeBackgroundColor: string;
        activeForegroundColor: string;
    };
    footer: {
        backgroundColor: string;
        foregroundColor: string;
    };
    socialMedia: ISocialMedia;
    apps: { android: string, iphone: string },
    contactUs: {
        phone: string;
        timing: string;
        email: string;
        address: string;
    };
    siteFeatures: ISiteFeatures,
    name: string;
    main: boolean;
}

@Injectable({ providedIn: 'root' })
export class SiteService {
    constructor(private http: HttpClient) {
        this.siteSetting = environment.site as ISiteSetting;
        this.features = (environment.site as ISiteSetting)?.siteFeatures;
    }

    public siteSetting: ISiteSetting;
    public features: ISiteFeatures;
    getSiteDetails() {
        return this.http.get<any>(`${environment.apiUrl}/site`).pipe(tap(res => {
            if (res.code == 200) {
                this.siteSetting = res.site;
                this.features = res.site?.siteFeatures;
            }
        }));
    }

    feature(feature) {
        return this.http.get<any>(`${environment.apiUrl}/site/feature/${feature}`);
    }
}
